import { SubTask, CreateSubTaskRequest, UpdateSubTaskRequest } from '../types/todo';
import { apiCall } from './authApi';
import { handleResponse } from './todoApi';

export const subTaskApi = {
  /**
   * Get all sub-tasks for a specific parent todo item
   */
  getSubTasks: async (parentTodoItemId: number, userEmail: string): Promise<SubTask[]> => {
    const response = await apiCall(
      `/SubTasks?parentTodoItemId=${parentTodoItemId}&userEmail=${encodeURIComponent(userEmail)}`
    );
    return handleResponse(response);
  },

  /**
   * Get a specific sub-task by ID
   */
  getSubTask: async (id: number, userEmail: string): Promise<SubTask> => {
    const response = await apiCall(
      `/SubTasks/${id}?userEmail=${encodeURIComponent(userEmail)}`
    );
    return handleResponse(response);
  },

  /**
   * Create a new sub-task
   */
  createSubTask: async (data: CreateSubTaskRequest, userEmail: string): Promise<SubTask> => {
    const response = await apiCall(`/SubTasks?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  /**
   * Update an existing sub-task
   */
  updateSubTask: async (id: number, data: UpdateSubTaskRequest, userEmail: string): Promise<SubTask> => {
    const response = await apiCall(`/SubTasks/${id}?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  /**
   * Delete a sub-task
   */
  deleteSubTask: async (id: number, userEmail: string): Promise<void> => {
    const response = await apiCall(`/SubTasks/${id}?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'DELETE'
    });
    await handleResponse(response);
  },

  /**
   * Toggle the completion status of a sub-task
   */
  toggleSubTask: async (id: number, userEmail: string): Promise<SubTask> => {
    const response = await apiCall(`/SubTasks/${id}/toggle?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'POST'
    });
    return handleResponse(response);
  },

  /**
   * Reorder sub-tasks within a parent todo item
   */
  reorderSubTasks: async (parentTodoItemId: number, orderedIds: number[], userEmail: string): Promise<void> => {
    const response = await apiCall(`/SubTasks/reorder?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'PATCH',
      body: JSON.stringify({ parentTodoItemId, orderedIds })
    });
    await handleResponse(response);
  }
};
